import React, { useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { BiX } from "react-icons/bi";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select";
import {
  applyTrivvyTitleText,
  DIFFICULTY_LEVELS,
  getTrivvyTitleText,
  isTrivvyGeneratedFromCustomTemplates,
} from "../data";

export default function DuplicateTriviaPopup({
  open,
  onClose,
  item,
  afterDuplicateSuccess,
  isMessaging,
  isKc
}) {
  // Stripped, not raw: seeding from item.name put the title's markup into a
  // plain input and persisted "Copy of <p><strong>Hi</strong></p>".
  const [duplicateTrivvyName, setDuplicateTrivvyName] = useState(
    `Copy of ${getTrivvyTitleText(item)}`
  );

  const [difficultyLevel, setDifficultyLevel] = useState(0);

  const duplicateTrivvy = () => {
    axios
      .post(url.duplicateTrivia, {
        currentTriviaId: item._id,
        // Carries the source title's styling onto the copy, same as rename.
        newDuplicateTrivvyName: applyTrivvyTitleText(
          item.name,
          duplicateTrivvyName
        ),
        difficultyLevel,
        isMessaging: isMessaging || false,
        isKc: isKc || false,
      })
      .then(({ data }) => {
        afterDuplicateSuccess(data.data);
        setTimeout(() => {
          onClose();
        }, 1000);
      })
      .catch((err) => {
        toastContainer("Error while duplicating Trivvy", "error");
      });
  };
  return (
    <Modal isOpen={open} size="sm" centered>
      <ModalHeader
        className="trivia_modal_header_bg"
        close={
          <BiX
            className="cursor-pointer"
            color="gray"
            size={30}
            onClick={() => onClose()}
          />
        }
      >
        Duplicate Trivvy
      </ModalHeader>

      <ModalBody className="p-3">
        {/* No top margin here: ModalBody's own p-3 supplies the 16px inset, so an
            extra mt-3 doubled it to 32px and left the modal top-heavy — obvious
            once the Question Difficulty block is gone on Surveys. */}
        <div>
          <p>
            Are you sure you want to duplicate{" "}
            <b>{getTrivvyTitleText(item)}</b>.
          </p>

          {/* Question Difficulty applies to Knowledge Checks only, so it is not
              offered when duplicating a Survey. Excluding SURVEY rather than
              requiring KNOWLEDGE_CHECK keeps older templates that have no
              triviaCategoryType behaving exactly as before. */}
          {item &&
          item.triviaType == 1 &&
          item.triviaCategoryType !== "SURVEY" &&
          !isTrivvyGeneratedFromCustomTemplates(item) ? (
            <div className="my-3">
              <Label>Question Difficulty</Label>
              <Select
                options={[
                  { label: "No change", value: 0 },
                  ...DIFFICULTY_LEVELS,
                ]}
                value={difficultyLevel}
                onChange={(e) => {
                  if (e) {
                    setDifficultyLevel(e.value);
                  } else {
                    setDifficultyLevel(0);
                  }
                }}
                placeholder={"Select difficulty level"}
              />
            </div>
          ) : (
            ""
          )}

          {/* mt-3 rather than my-3: this is the last block, so its bottom margin
              stacked with ModalBody's p-3 for a 32px gap above the footer while
              the sides sat at 16px. */}
          <div className="mt-3">
            <Label>Please set new duplicate Trivvy name</Label>
            <Input
              value={duplicateTrivvyName}
              placeholder="Enter new duplicate Trivvy name"
              onChange={(e) => {
                setDuplicateTrivvyName(e.target.value);
              }}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="trivia-action-button-secondary duplicate-btn-cancel"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={duplicateTrivvy} className="trivia-action-button-main">
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
}
